
import { defineComponent, onBeforeMount, ref } from 'vue';
// import axios from 'axios';
import axios, { AxiosError } from 'axios';
import ErrorMessage from '@/components/global/ErrorMessage.vue';
import { XIcon } from 'vue-feather-icons';
// eslint-disable-next-line
import router from '@/router';
// import { getPreSignedUrl } from '@/utils/learner_submit_service';
import { getLearnerStatus } from '@/utils/done_service';
import GenericModal from '@/components/global/GenericModal.vue';
import Greetings from '@/components/global/Greetings.vue';
import { downloadLearnerSubmission, getPreAuthUrl, learnerTaskToReview, saveReview, plagiarismSubmissionUPload } from '../utils/learner_review_service';
// import store from '@/store';

export default defineComponent({
  name: 'LearnerSubmitTask',
  // props: ['query'],
  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { ErrorMessage, GenericModal, XIcon, Greetings },
  setup(props) {
    // onMounted(async () => {
    //   // await store.dispatch('landing/getSystemUnderMaintenance');
    // });
    // const welcomeMsg = computed(() => store.getters['landing/welcomeMessage']);
    // return { welcomeMsg };
    const isButtonEnabled = ref(false);
    const revieweeDetails = ref();
    const reviewedLearnerSubmission = ref(false);
    const reviewerComment = ref('');
    const learnerTaskId = ref();
    const skillId = ref(localStorage.getItem('skillId'));
    const proficiencyId = ref(localStorage.getItem('profId'));
    const programId = ref(localStorage.getItem('programId'));
    const programName = ref(localStorage.getItem('programName'));
    const skill = ref();
    const proficiency = ref();
    const reviewerHoldTime = ref();
    const preSignedUrl = ref();
    const renderReady = ref();
    const errorResponse = ref();
    const isPlagiarised = ref();
    const showErrorMessage = ref(false);
    const questionEnable = ref(false);
    const showplagiarismUpload = ref(false);
    const isPlagiarismEnabled = ref(false);
    const errorMessage = ref();
    const successMessage = ref();
    const plagiarismSubmissionFile = ref();
    const plagiarismSubmission = ref();
    const plagiarismUploadedStatus = ref();
    const evidenceFileName = ref();
    const ext = ref();
    const plagUrlForUpload = ref();
    const helpmateLink = ref(localStorage.getItem('helpmateLink'));
    const plagiarismCheckOne = ref([]);
    const isPlagiarizedChecked = ref(false);
    const likertScale = ref({});
    const modalVisible = ref(false);
    const modalMessage = ` 
          <div class="px-4">
            <div class="font-bold text-left mb-3"><strong>By selecting "Yes," you confirm the following: </strong></div>
            <ul class="list-disc text-left px-6">
              <li>The submission is extensively copied from the Internet without proper source referencing. </li>
              <li>The learner will receive a <strong>'Fail'</strong> notification, with a copy sent to the respective manager. </li>
            </ul>
          </div>`;
    const minReviewWordCount = ref(false);
    const questionWordCount = ref(0);
    const accessRestrictionCheck = ref(false);
    const fileInputKey = ref(0);
    const modalVisible2 = ref(false);
    const modalMessage2 = `<div class="px-4">
              <ul class="list-disc text-left px-6">
                <li>The learner will receive a <strong>'Fail'</strong> notification, with a copy sent to the respective manager. </li>
                <li class="pt-2">Please confirm the review to proceed.  </li>
              </ul>
          </div>`;

    const checkQuestionLength = (ques: string) => {
      questionWordCount.value = ques.split(' ').filter((word: string) => word !== '').length;
      minReviewWordCount.value = questionWordCount.value >= 10;
    };
    const checkOne = () => {
      plagiarismCheckOne.value = [];
    };
    const clearFile = async () => {
      fileInputKey.value += 1;
      plagiarismSubmissionFile.value = null;
    };
    // const fetchLearnerPreAuthURL = async () => {
    //   try {
    //     const data = {
    //       file_name: revieweeDetails.value.learner_submission,
    //       task_id: revieweeDetails.value.reviewee_id,
    //     };
    //     // renderReady.value = false;
    //     // preSignedUrl.value = await getPreAuthUrl('/v1/pretAuthUrlForDownload', data);
    //     const res = await getPreAuthUrl('/v1/pretAuthUrlForDownload', data);
    //     // renderReady.value = true;
    //     return res;
    //   } catch (error) {
    //     console.log('Save Task Data', error);
    //     return error;
    //   }
    // };

    onBeforeMount(async () => {
      try {
        // console.log('Before Mount');
        learnerTaskId.value = props.query.learner_task_id;
        renderReady.value = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res: any = await learnerTaskToReview(`/learnerTaskToReview/${learnerTaskId.value}`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const reveiwTaskRes: any = res.data;
        renderReady.value = true;
        if (reveiwTaskRes.data.is_learner_not_allowed) {
          console.log('learner on hold submit task');
          router.push({ path: '/solidify', query: { skill_id: skillId.value, proficiency_id: proficiencyId.value, program_id: programId.value } });
        }
        // console.log('reveiwTaskRes', reveiwTaskRes);
        if (reveiwTaskRes.data.errorMessage) {
          // localStorage.setItem('errorMsg', reveiwTaskRes.data.errorMessage);
          // router.push({ path: '/solidify/Error' });
          showErrorMessage.value = true;
          errorResponse.value = reveiwTaskRes.data.errorMessage;
        } else if (reveiwTaskRes.data.message) {
          localStorage.setItem('message', reveiwTaskRes.data.message);
          router.push({ name: 'SolidifyLearnerStatus', query: { isPerformReviewVisible: 'yes', learnerTaskId: learnerTaskId.value, isProxyReview: 'no', showChevron: 'yes' } });
        } else if (reveiwTaskRes.data.learner_status === 'Need Reviewer' || reveiwTaskRes.data.learner_status === 'Fail' || reveiwTaskRes.data.learner_status === 'Passed') {
          router.push({ name: 'SolidifyLearnerDone', query: { learner_task_id: learnerTaskId.value } });
        } else {
          revieweeDetails.value = reveiwTaskRes.data;
          likertScale.value = revieweeDetails.value.task_details.likertScale ? revieweeDetails.value.task_details.likertScale : {};
          skill.value = revieweeDetails.value.skill;
          proficiency.value = revieweeDetails.value.proficiency;
          const holdTIme = parseInt(revieweeDetails.value.reviewer_hold_time_in_minutes, 10) / 60;
          const plagiarismEnabled = revieweeDetails.value.is_plagiarism_enabled ? revieweeDetails.value.is_plagiarism_enabled : false;
          plagUrlForUpload.value = revieweeDetails.value.url_to_upload_plag_evidence;
          console.log(`plagiarismEnabled ${plagiarismEnabled}`);
          if (plagiarismEnabled === true) {
            isPlagiarismEnabled.value = true;
          } else {
            isPlagiarismEnabled.value = false;
          }
          // console.log(`type of  ${typeof holdTIme}`);
          // console.log(`Number.isInteger(holdTIme) ${Number.isInteger(holdTIme)}`);
          if (Number.isInteger(holdTIme)) {
            reviewerHoldTime.value = holdTIme;
          } else {
            reviewerHoldTime.value = holdTIme.toFixed(2);
          }
          // console.log('Api revieweeTaskId', JSON.stringify(revieweeDetails.value));
          // await fetchLearnerPreAuthURL();
        }
      } catch (error) {
        renderReady.value = true;
        // console.log(`error peer review ${error}`);
        // localStorage.setItem('errorMsg', 'There is an issue while fetching peer learner task to review, please contact with helpmate');
        // router.push({ path: 'Error' });
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          // console.log(err.response?.data);
          errorResponse.value = (err.response?.data as { message: string })?.message;
          // console.log(`errorMessage.value ${errorMessage.value}`);
        } else {
          errorResponse.value = 'There is an issue while fetching peer learner task to review, please contact helpmate.';
        }
        showErrorMessage.value = true;
      }
    });
    const enableSubmitButton = () => {
      // console.log('inside enable submit button');
      let allQuestionAnswered = true;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      revieweeDetails.value.task_details.task_questions.forEach((que: any, index: number) => {
        console.log(`que.response ${que.response} index ${index}`);
        if (que.response) {
          console.log(`inside if allQuestionAnswered before${allQuestionAnswered}`);
          allQuestionAnswered = allQuestionAnswered && true;
          // console.log(`inside if allQuestionAnswered after ${allQuestionAnswered}`);
          // eslint-disable-next-line no-param-reassign
          // que.response = parseInt(que.response, 10);
          // console.log(`inside if  que.response after ${que.response}`);
        } else {
          console.log(`inside else allQuestionAnswered before ${allQuestionAnswered}`);
          allQuestionAnswered = allQuestionAnswered && false;
          // console.log(`inside else allQuestionAnswered after ${allQuestionAnswered}`);
        }
      });
      console.log(`allQuestionAnswered ${JSON.stringify(allQuestionAnswered)} `);
      // if (!allQuestionAnswered || (revieweeDetails.value.task_details.task_type === 'Desktop' && !reviewedLearnerSubmission.value) || !reviewerComment.value.trim()) isButtonEnabled.value = false;
      if (!allQuestionAnswered || (revieweeDetails.value.task_details.task_type === 'Desktop' && !reviewedLearnerSubmission.value)) isButtonEnabled.value = false;
      else isButtonEnabled.value = true;
      console.log(`isButtonEnabled ${JSON.stringify(isButtonEnabled)} `);
    };

    const learnerSubmissionClicked = async () => {
      try {
        const data = {
          file_name: revieweeDetails.value.learner_submission,
          task_id: revieweeDetails.value.reviewee_id,
        };
        renderReady.value = false;
        // preSignedUrl.value = await getPreAuthUrl('/v1/pretAuthUrlForDownload', data);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res: any = await getPreAuthUrl('/v1/pretAuthUrlForDownload', data);
        preSignedUrl.value = res.data.preSignedUrl;
        await downloadLearnerSubmission(preSignedUrl.value, revieweeDetails.value.learner_submission);
        renderReady.value = true;
        reviewedLearnerSubmission.value = true;
        enableSubmitButton();
      } catch (error) {
        renderReady.value = true;
        // console.log('Save Task Data', error);
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          // console.log(err.response?.data);
          errorResponse.value = (err.response?.data as { message: string })?.message;
          // console.log(`errorMessage.value ${errorMessage.value}`);
        } else {
          errorResponse.value = 'There is an issue while donwloading learner submission, please contact helpmate.';
        }
        showErrorMessage.value = true;
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selectedFile = async (event: any) => {
      try {
        // eslint-disable-next-line prefer-destructuring
        const file = event.target.files[0];
        const fileName = event.target.files[0].name;

        const fileSize = event.target.files[0].size / 1024 / 1024;
        if (fileSize > 5) {
          errorMessage.value = 'fileSize greater than 5 MB';
          setTimeout(() => {
            errorMessage.value = null;
          }, 6000);
        } else {
          plagiarismSubmissionFile.value = file;
          plagiarismSubmission.value = fileName;
        }
      } catch (error) {
        plagiarismSubmissionFile.value = null;
        plagiarismSubmission.value = null;
        console.log(error);
      }
    };
    // const uploadPlagiarismEvidence = async () => {
    //   // if (!plagiarismSubmissionFile.value) {
    //   //   errorMessage.value = 'Please upload plagiarism evidence screenshot';
    //   //   setTimeout(() => {
    //   //     errorMessage.value = null;
    //   //   }, 6000);
    //   // } else {
    //   // const now = moment().format('llll');
    //   evidenceFileName.value = plagiarismSubmission.value;
    //   ext.value = plagiarismSubmission.value.split('.').pop();
    //   renderReady.value = false;
    //   const keyName = `${learnerTaskId.value}.${ext.value}`;
    //   console.log('evidenceFileName value', evidenceFileName.value);
    //   if (ext.value !== 'png' || ext.value !== 'jpeg' || ext.value !== 'jpg') {
    //     renderReady.value = true;
    //     errorMessage.value = 'You can upload only jpg, jpeg, and png';
    //     setTimeout(() => {
    //       errorMessage.value = null;
    //     }, 6000);
    //     return;
    //   }
    //   // eslint-disable-next-line @typescript-eslint/no-explicit-any
    //   const preSignedRes: any = await getPreSignedUrl('/v1/pretAuthUrlForUpload', {
    //     folder_name: 'plagiarism_evidence',
    //     key_name: keyName,
    //   });
    //   console.log('presigned URL', preSignedRes);
    //   preSignedUrl.value = preSignedRes.data.preSignedUrl;
    //   // console.log('presigned url', preSignedUrl.value);
    //   // eslint-disable-next-line @typescript-eslint/no-explicit-any
    //   plagiarismUploadedStatus.value = await plagiarismSubmissionUPload(preSignedUrl.value, plagiarismSubmissionFile.value);
    //   isPlagiarised.value = true;
    //   // showplagiarismUpload.value = false;
    //   // renderReady.value = true;
    //   // }
    // };
    const submitReview = async () => {
      try {
        renderReady.value = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any

        // console.log(`inside submit click ${JSON.stringify(revieweeDetails)}`);
        // console.log(`isPlagiarismEnabled ${isPlagiarismEnabled.value}`);
        if (isPlagiarismEnabled.value) {
          console.log(`isPlagiarised.value ${isPlagiarised.value}`);
          if (isPlagiarised.value && !accessRestrictionCheck.value) {
            if (!plagiarismSubmissionFile.value) {
              renderReady.value = true;
              errorMessage.value = 'Please upload plagiarism evidence screenshot';
              setTimeout(() => {
                errorMessage.value = null;
              }, 6000);
              // await uploadPlagiarismEvidence();
              // renderReady.value = true;
              // if (plagiarismUploadedStatus.value === undefined)
              return;
            }
            evidenceFileName.value = plagiarismSubmission.value;
            // const lastIndex = plagiarismSubmission.value.lastIndexOf('.');
            // ext.value = plagiarismSubmission.value.slice(lastIndex + 1, plagiarismSubmission.value.length);
            console.log('ext.value', ext.value);
            // ext.value = plagiarismSubmission.value.lastIndexsplit('.').pop();
            renderReady.value = false;
            // const keyName = `${learnerTaskId.value}.${ext.value}`;
            console.log('evidenceFileName value', evidenceFileName.value);
            if (!plagiarismSubmission.value.endsWith('png') && !plagiarismSubmission.value.endsWith('PNG')) {
              renderReady.value = true;
              errorMessage.value = 'You can upload only jpg, jpeg, and png';
              setTimeout(() => {
                errorMessage.value = null;
              }, 6000);
              return;
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            // const preSignedRes: any = await getPreSignedUrl('/v1/pretAuthUrlForUpload', {
            //   folder_name: 'plagiarism_evidence',
            //   key_name: keyName,
            // });
            // console.log('presigned URL', preSignedRes);
            // preSignedUrl.value = preSignedRes.data.preSignedUrl;
            // console.log('presigned url', preSignedUrl.value);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const learnerStatus: any = await getLearnerStatus('learnerStatus', revieweeDetails.value.reviewee_id);

            if (learnerStatus.data.current_status === 'Need Reviewer' || learnerStatus.data.current_status === 'Need Reviewer and Need Reviewee') {
              plagiarismUploadedStatus.value = await plagiarismSubmissionUPload(plagUrlForUpload.value, plagiarismSubmissionFile.value);
              isPlagiarised.value = true;
            }
          }
          if (isPlagiarised.value === undefined) {
            renderReady.value = true;
            errorMessage.value = 'Please Select Plagiarism Checkbox';
            setTimeout(() => {
              errorMessage.value = null;
            }, 6000);
            return;
          }
          // if (isPlagiarised.value === 'false') isPlagiarised.value = false;
        }

        // console.log('return before submit');
        // return;
        // await uploadPlagiarismEvidence();

        const data = {
          reviewer_task_id: learnerTaskId.value,
          reviewee_task_id: revieweeDetails.value.reviewee_id,
          reviewer_comment: reviewerComment.value,
          reviewer_response: revieweeDetails.value.task_details.task_questions,
          is_plagiarised: isPlagiarised.value,
          plagiarism_evidence: evidenceFileName.value,
        };
        // console.log('Rveviewee data', data);
        // return;
        // console.log('plagiarismUploadedStatus.value', plagiarismUploadedStatus.value);
        // console.log(`params ${JSON.stringify(data)}`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const response: any = await saveReview('/learnerReview', data);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res: any = response.data;
        // console.log(`res ${JSON.stringify(res)}`);
        if (res.message) {
          // need to move to status page
          renderReady.value = false;
          localStorage.setItem('message', res.message);
          router.push({ name: 'SolidifyLearnerStatus', query: { isPerformReviewVisible: 'yes', learnerTaskId: learnerTaskId.value, isProxyReview: 'no', showChevron: 'yes' } });
        }
        if (res.reviewer_updated_status === 'Need Reviewer and Need Reviewee' || res.reviewer_updated_status === 'Need Reviewee') {
          renderReady.value = false;
          router.push({ name: 'SolidifyLearnerPeerReview', query: { learner_task_id: learnerTaskId.value } });
          router.go(0);
        }
        if (res.reviewer_updated_status === 'Need Reviewer' || res.reviewer_updated_status === 'Passed' || res.reviewer_updated_status === 'Fail') {
          renderReady.value = false;
          router.push({ name: 'SolidifyLearnerDone', query: { learner_task_id: learnerTaskId.value } });
        }
        // if (res.error) {
        //   renderReady.value = true;
        //   localStorage.setItem('errorMsg', 'There is an issue while fetching peer learner task to review, please contact with helpmate');
        // router.push({ path: 'Error' });
        // }
        // } else {
        //   renderReady.value = true;
        //   errorMessage.value = 'This learner is no more available for review';
        //   setTimeout(() => {
        //     errorMessage.value = null;
        //   }, 6000);
        // }
      } catch (error) {
        renderReady.value = true;
        // localStorage.setItem('errorMsg', 'There is an issue while submitting peer review, please contact with helpmate');
        // router.push({ path: 'Error' });
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          // console.log(err.response?.data);
          errorResponse.value = (err.response?.data as { message: string })?.message;
          // console.log(`errorMessage.value ${errorMessage.value}`);
        } else {
          errorResponse.value = 'There is an issue while submitting peer review, please contact with helpmate.';
        }
        showErrorMessage.value = true;
      }
    };
    const cancelPlagiarism = () => {
      modalVisible.value = false;
      modalVisible2.value = false;
      isPlagiarised.value = undefined;
      isPlagiarizedChecked.value = false;
      for (let index = 0; index < revieweeDetails.value.task_details.task_questions.length; index += 1) {
        revieweeDetails.value.task_details.task_questions[index].response = '';
      }
      showplagiarismUpload.value = false;
      questionEnable.value = false;
      enableSubmitButton();
      checkOne();
    };
    const confirmPlagiarism = () => {
      modalVisible.value = false;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const checkPlagiarised = async (event: any, isPlagiarise: any) => {
      isPlagiarizedChecked.value = event.target.checked;
      console.log(`isPlagiarizedChecked ${isPlagiarizedChecked.value}`);
      isPlagiarised.value = isPlagiarise;
      console.log('isPlagiarised', { isPlagiarised: isPlagiarised.value });
      if (isPlagiarizedChecked.value === true && isPlagiarise === true) {
        showplagiarismUpload.value = true;
        modalVisible.value = true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        for (let index = 0; index < revieweeDetails.value.task_details.task_questions.length; index += 1) {
          revieweeDetails.value.task_details.task_questions[index].response = '0';
        }
        questionEnable.value = true;
        await enableSubmitButton();
      } else if (isPlagiarizedChecked.value === true && isPlagiarise === false) {
        for (let index = 0; index < revieweeDetails.value.task_details.task_questions.length; index += 1) {
          revieweeDetails.value.task_details.task_questions[index].response = '';
        }
        showplagiarismUpload.value = false;
        questionEnable.value = false;
        await enableSubmitButton();
      } else {
        for (let index = 0; index < revieweeDetails.value.task_details.task_questions.length; index += 1) {
          revieweeDetails.value.task_details.task_questions[index].response = '';
        }
        showplagiarismUpload.value = false;
        isPlagiarised.value = undefined;
        questionEnable.value = false;
        await enableSubmitButton();
      }
    };
    const finalPlagWarningPopup = async () => {
      modalVisible2.value = true;
    };
    return {
      revieweeDetails,
      isButtonEnabled,
      enableSubmitButton,
      learnerSubmissionClicked,
      reviewerComment,
      submitReview,
      skill,
      proficiency,
      reviewerHoldTime,
      preSignedUrl,
      errorResponse,
      showErrorMessage,
      helpmateLink,
      renderReady,
      questionEnable,
      isPlagiarised,
      showplagiarismUpload,
      errorMessage,
      successMessage,
      selectedFile,
      plagiarismSubmissionFile,
      plagiarismSubmission,
      // uploadPlagiarismEvidence,
      isPlagiarismEnabled,
      evidenceFileName,
      checkPlagiarised,
      programId,
      programName,
      ext,
      plagUrlForUpload,
      plagiarismCheckOne,
      isPlagiarizedChecked,
      checkOne,
      likertScale,
      confirmPlagiarism,
      cancelPlagiarism,
      modalVisible,
      modalMessage,
      checkQuestionLength,
      minReviewWordCount,
      questionWordCount,
      accessRestrictionCheck,
      clearFile,
      fileInputKey,
      modalVisible2,
      finalPlagWarningPopup,
      modalMessage2,
    };
  },
});
